var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "user-app-main" }, [
    _c("p", [
      _c("span", { staticClass: "blue" }, [_vm._v(_vm._s(_vm.name))]),
      _vm._v("，你好！欢迎使用资产管理系统~"),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }